import axios from 'axios';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { NavLink, useNavigate, useParams } from 'react-router-dom';


const Product = () => {
    const { apiUrl, apiHeadersJson, apiHeadersFile, store_id } = useContext(ConfigContext);
    const [CategoryId, setCategoryId] = useState('');
    const [ProductName, setProductName] = useState('');
    const [ProductBarCode, setProductBarCode] = useState('');
    const [ProductId, setProductId] = useState(null);
    const [ProductPurchaseRate, setProductPurchaseRate] = useState('');
    const [ProductSaleRate, setProductSaleRate] = useState('');
    const [ProductRetailRate, setProductRetailRate] = useState('');
    const [ProductForOrder, setProductForOrder] = useState(0);
    const [ProductShow, setProductShow] = useState(1);
    const [ProductMinAlert, setProductMinAlert] = useState('');
    const [ProductImage, setProductImage] = useState(null);
    const [OldProductImage, setOldProductImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [getLoading, setgetLoading] = useState(true);
    const { product_id } = useParams();
    const headers = apiHeadersJson;
    const headersfile = apiHeadersFile;
    const toast = useRef(null);
    const navigate = useNavigate();

    const HandleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('store_id', store_id);
        formData.append('category_id', CategoryId);
        formData.append('product_name', ProductName);
        formData.append('product_barcode', ProductBarCode);
        formData.append('product_purchase_rate', ProductPurchaseRate);
        formData.append('product_sale_rate', ProductSaleRate);
        formData.append('product_retail_rate', ProductRetailRate);
        formData.append('product_show', ProductShow);
        formData.append('product_min_alert', ProductMinAlert);
        formData.append('product_for_order', ProductForOrder);
        if (ProductImage) {
            formData.append('product_image', ProductImage);
        }
        if (ProductId) {
            formData.append('product_id', ProductId);
        }

        try {
            const response = await axios.post(`${apiUrl}/Masters/CreateProduct`, formData, { headers: headersfile });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    };

    const fetchcategorys = async () => {
        try {
            const [categoryRes] = await Promise.all([
                axios.get(`${apiUrl}/Masters/GetCategoryList`, { params: { store_id: store_id }, headers }),
            ]);
            setCategories(categoryRes.data.data || []);
        } catch (error) {
            console.error('Error fetching categorys:', error);
        }
    };

    useEffect(() => {
        store_id && fetchcategorys();
        setCategoryId('')
    }, [store_id]);

    const handleResetForm = () => {
        setCategoryId('');
        setProductId('');
        setProductName('');
        setProductBarCode('');
        setProductImage(null);
        setOldProductImage(null);
        setProductPurchaseRate('');
        setProductMinAlert('');
        setProductForOrder(0);
        setProductShow(1);
        setProductSaleRate('');
        setProductRetailRate('');
        if (product_id) {
            navigate('/ProductList')
        }
    };


    const GetInfo = async () => {
        try {
            setgetLoading(true);
            const response = await axios.get(`${apiUrl}/Masters/GetProductInfo`, { params: { product_id }, headers });
            const { success, data, message } = response.data;
            if (success) {
                setProductId(data[0].product_id);
                setProductName(data[0].product_name);
                setProductBarCode(data[0].product_barcode);
                setOldProductImage(data[0].product_image_url);
                setProductPurchaseRate(data[0].product_purchase_rate);
                setProductMinAlert(data[0].product_min_alert);
                setProductSaleRate(data[0].product_sale_rate);
                setProductRetailRate(data[0].product_retail_rate);
                setProductShow(data[0].product_show);
                setProductForOrder(data[0].product_for_order);
                setCategoryId(data[0].category_id);
                setgetLoading(false);
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setgetLoading(false);
        }
    };

    const handleImageSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProductImage(file);
        }
    };

    const handleImageRemove = () => {
        setProductImage(null);
    };

    useEffect(() => {
        product_id && GetInfo();
    }, [product_id]);

    if (product_id && getLoading) {
        return (
            <div className='d-flex justify-content-center align-items-center vh-100'>
                <div class="spinner-grow text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center my-4">
                    <div className="main-heading">
                        <h6>Product</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Masters/Product</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="bg-dark text-white p-3 rounded-top d-flex flex-wrap justify-content-between align-items-center">
                                <h4>Product</h4>
                                <NavLink to={'/ProductList'}><Button icon="pi pi-list" rounded={true} severity="secondary" /></NavLink>
                            </div>
                            <form className="p-3" onSubmit={HandleSubmit}>
                                <div className="row">
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Select Category</label>
                                        <select
                                            className="form-select"
                                            value={CategoryId || ""}
                                            required
                                            onChange={(e) => setCategoryId(e.target.value)}>

                                            <option value="" disabled>
                                                Select a Category
                                            </option>
                                            {categories.map((category) => (
                                                <option key={category.category_id} value={category.category_id}>
                                                    {category.category_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Product Name</label>
                                        <input
                                            type="text"
                                            value={ProductName}
                                            className="form-control"
                                            onChange={(e) => setProductName(e.target.value)}
                                            required
                                            placeholder="Enter Product Name"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Product Bar Code</label>
                                        <input
                                            type="text"
                                            value={ProductBarCode}
                                            className="form-control"
                                            onChange={(e) => setProductBarCode(e.target.value)}
                                            placeholder="Enter Product Bar Code"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Purchase Rate</label>
                                        <input
                                            type="number"
                                            value={ProductPurchaseRate}
                                            className="form-control"
                                            onChange={(e) => setProductPurchaseRate(e.target.value)}
                                            required
                                            placeholder="Enter Purchase Rate"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Sale Rate</label>
                                        <input
                                            type="number"
                                            value={ProductSaleRate}
                                            required
                                            className="form-control"
                                            onChange={(e) => setProductSaleRate(e.target.value)}
                                            placeholder="Enter Sale Rate"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Retail Rate</label>
                                        <input
                                            type="number"
                                            value={ProductRetailRate}
                                            required
                                            className="form-control"
                                            onChange={(e) => setProductRetailRate(e.target.value)}
                                            placeholder="Enter Retail Rate"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Product Min Stock Alert</label>
                                        <input
                                            type="number"
                                            value={ProductMinAlert}
                                            className="form-control"
                                            onChange={(e) => setProductMinAlert(e.target.value)}
                                            placeholder="Enter Product Min Stock Alert"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Show Product</label>
                                        <div className="flex flex-wrap justify-content-start gap-3">
                                            <div className="flex align-items-center">
                                                <Checkbox inputId="ingredient1" name="product" value="yes" onChange={e => setProductShow(1)} checked={ProductShow === 1} />
                                                <label htmlFor="ingredient1" className="ml-2">Yes</label>
                                            </div>
                                            <div className="flex align-items-center">
                                                <Checkbox inputId="ingredient2" name="product" value="yes" onChange={e => setProductShow(0)} checked={ProductShow === 0} />
                                                <label htmlFor="ingredient2" className="ml-2">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Product For Order</label>
                                        <div className="flex flex-wrap justify-content-start gap-3">
                                            <div className="flex align-items-center">
                                                <Checkbox inputId="ingredient1" name="product" value="yes" onChange={e => setProductForOrder(1)} checked={ProductForOrder === 1} />
                                                <label htmlFor="ingredient1" className="ml-2">Yes</label>
                                            </div>
                                            <div className="flex align-items-center">
                                                <Checkbox inputId="ingredient2" name="product" value="yes" onChange={e => setProductForOrder(0)} checked={ProductForOrder === 0} />
                                                <label htmlFor="ingredient2" className="ml-2">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Custom File Input with Remove Button */}
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Product Image</label>
                                        <div className="p-inputgroup">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                className="p-inputtext"
                                                onChange={handleImageSelect}
                                            />
                                            {ProductImage && (
                                                <Button
                                                    icon="pi pi-times"
                                                    className="p-button-danger"
                                                    onClick={handleImageRemove}
                                                    style={{ marginLeft: '10px' }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-4 my-3">
                                        {ProductImage ? (
                                            <div className="mt-2">
                                                <img
                                                    src={URL.createObjectURL(ProductImage)}
                                                    alt="Preview"
                                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                />
                                            </div>
                                        ) :
                                            <div className="mt-2 text-primary">
                                                Select Image For Preview
                                            </div>
                                        }
                                        {ProductImage && product_id && (
                                            <div className="mt-2">
                                                <i className="pi pi-arrow-right-arrow-left" style={{ fontSize: '2rem' }}></i>
                                            </div>
                                        )}
                                        {OldProductImage && product_id && (
                                            <div className="mt-2">
                                                <img
                                                    src={OldProductImage}
                                                    alt="Preview"
                                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-4 d-flex justify-content-between align-items-center">

                                        <Button type="submit" label={loading ? "Loading..." : ProductId ? "Update" : "Submit"} icon="pi pi-save" severity='success' size='small' loading={loading} />
                                        {ProductId && <Button type="button" label={'Reset'} severity="secondary" text raised onClick={handleResetForm} size='small' className='float-end' loading={loading} />}
                                        {/* <div className="">
                                        </div> */}
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Product;
